import { useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { Box, CssBaseline, ThemeProvider } from '@material-ui/core';
import './i18n';
import RTL from './components/RTL';
import SettingsDrawer from './components/SettingsDrawer';
import WhatsappDrawer from './pages/pricingpage/WhatsappDrawer'
import SplashScreen from './components/SplashScreen';
import { gtmConfig } from './config';
import useAuth from './hooks/useAuth';
import useScrollReset from './hooks/useScrollReset';
import useSettings from './hooks/useSettings';
import gtm from './lib/gtm';
import routes from './routes';
import { createCustomTheme } from './theme';
import LogoutPopup from './contexts/timer'
import { useTranslation } from 'react-i18next';
import { ArchiveNote } from './__fakeApi__/ServerConfig';
const App = () => {
  const content = useRoutes(routes);
  const { settings } = useSettings();
  const auth = useAuth();
  const { i18n } = useTranslation();
  const lang= localStorage.getItem("lang")
  //i18n.changeLanguage(lang);
  useScrollReset();

  useEffect(() => {
    i18n.changeLanguage(lang);
    gtm.initialize(gtmConfig);
  }, []);

  const theme = createCustomTheme({
    boldTables: settings.boldTables,
    tableFontSize: settings.tableFontSize,
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    roundedCorners: settings.roundedCorners,
    theme: settings.theme
  });

  return (
    <ThemeProvider theme={theme}>
       <LogoutPopup />
      <RTL direction={settings.direction}>
        <CssBaseline />
       
        <Toaster position="top-center" />
        <SettingsDrawer />
        <WhatsappDrawer />
        {ArchiveNote && (
          <Box
            sx={{
              position: 'fixed',
              top: 8,
              left: '50%',
              transform: 'translateX(-50%)',
              zIndex: 2000,
              pointerEvents: 'none',
              px: 2,
              py: 0.75,
              borderRadius: 1,
              bgcolor: 'warning.main',
              color: 'warning.contrastText',
              fontWeight: 'bold',
              fontSize: 14,
              whiteSpace: 'nowrap',
              boxShadow: 3,
            }}
          >
            {ArchiveNote}
          </Box>
        )}
        {auth.isInitialized ? content : <SplashScreen />}
      </RTL>
    </ThemeProvider>
  );
};

export default App;
